const RESULT_VARIATIONS = Object.freeze({
  ACCEPTED_WITH_CONSIDERATION: `accepted_with_consideration`,
  HARD_REJECT: `hard_reject`,
})

export default RESULT_VARIATIONS
